module.exports = __webpack_public_path__ + "img/ur106-explosion.ab8d4f7d.jpg";